import DebugUANC from '../core/version/debug';

export const loadADOCEANScript = (): Promise<void> => {
    return new Promise<void>((resolve, reject) => {
        if (window.ado) return resolve();

        const { detection, event, UANC } = window.Inpl.Ad;

        const adoScript = document.createElement('script');
        adoScript.async = true;
        adoScript.type = 'text/javascript';
        adoScript.src = `${detection!.protocol}//${detection!.libraryPath}${process.env.ADO_LIB}.js`;

        const comment = document.createComment('Adocean: ado');
        const headTag = document.getElementsByTagName('head')[0];
        headTag.appendChild(comment);
        headTag.appendChild(adoScript);

        event?.subscribe('load', adoScript, () => {
            UANC instanceof DebugUANC && UANC.info('Adocean script loaded successfully');
            return resolve();
        });

        event?.subscribe('error', adoScript, () => {
            return reject(new Error('Error loading Adocean script'));
        });
        event?.subscribe('abort', adoScript, () => {
            return reject(new Error('Adocean script loading aborted'));
        });
    });
};
